import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignJustifySizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 19h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V9H3v2zm0-6v2h18V5H3z" />
  </svg>
);
export default IconAlignJustifySizeM;
